<template>
  <page-view class="proDetail tms-style">
    <div slot="pageRight" style="padding: 15px; background: #f0f6fb">
      <div class="product-detail" style="background: #fff">
        <div class="back-wrap">
          <el-button
            class="btn-nav-back"
            plain
            size="mini"
            icon="el-icon-back"
            @click="$router.go(-1)"
            >{{ $t('InvoiceInquiry.return') }}</el-button
          >
          <!-- <span class="back-arrow" @click="goToMall"><< 返回积分商城</span> -->
        </div>
        <div class="proInfo">
          <div class="imageBanner">
            <div>
              <PicZoom ref="piczoom" :boxSize="350" :imglist="prodcutPics" />
            </div>
          </div>
          <div class="proParams">
            <div class="proName">
              {{ data.CommodityName }}
            </div>
            <!-- <div class="pro-spec">
              {{ data.CommodityDescribe }}
            </div> -->
            <div class="pro-price">
              <span style="line-height: 30px"
                >{{ $t('PointsMall.PointsRequired') }} :
              </span>
              <!-- 显示商品规格的阶梯价 -->
              <div style="margin-left: 16px">
                <span
                  style="
                    text-align: center;
                    font-size: 14px;
                    color: #fb4748;
                    font-size: 26px;
                    font-weight: 600;
                  "
                >
                  {{
                    skuList[currentSku] &&
                    skuList[currentSku].DetailIntegral | formatWithCommas(0)
                  }}
                </span>
                <span
                  >{{ $t('PointsMall.Price') }} :¥{{
                    skuList[currentSku] &&
                    skuList[currentSku].DetailPrice | formatWithCommas(0)
                  }}
                </span>
              </div>
            </div>
            <div style="padding: 6px 24px">
              <div class="pro-detail">
                <span
                  class="pro-label"
                  style="width: 60px; line-height: 54px"
                  >{{ $t('PointsMall.ChooseType') }}</span
                >
                <span class="pro-content" style="line-height: 54px">: </span>
                <span>
                  <a-radio-group v-model="currentSku" @change="onChange">
                    <a-radio
                      v-for="(item, index) in skuList"
                      :key="index"
                      :value="index"
                      :class="[currentSku == index ? 'selected' : 'select']"
                    >
                      <el-tooltip
                        class="item"
                        effect="dark"
                        content="Top Left 提示文字"
                        placement="top-start"
                      >
                        <span>{{ item.Specifications }}</span>
                      </el-tooltip>
                    </a-radio>
                  </a-radio-group>
                </span>
              </div>
              <div class="pro-detail">
                <span
                  class="pro-label"
                  style="width: 76px; line-height: 54px"
                  >{{ $t('InvoiceInquiry.Instructions') }}</span
                >
                <span style="line-height: 54px">{{
                  specificationsRemark
                }}</span>
              </div>
              <!-- <div class="pro-detail">
                <span class="pro-label" style="width:60px;">品牌名称</span>
                <span class="pro-content" style="width:180px;color:#5BBDD9">: {{ data.pbrand }}</span>
                <span class="pro-label" style="width:60px;">商品型号</span>
                <span class="pro-content"> : {{ data.model }}</span>
              </div> -->
              <div
                style="
                  width: 100%;
                  height: 1px;
                  border-top: 1px dashed #e1e8f1;
                  margin: 16px 0px;
                "
              />
              <div class="pro-detail" style="height: 32px; line-height: 32px">
                <span
                  class="pro-label"
                  style="width: 60px; height: 32px; line-height: 32px"
                  >{{ $t('PointsMall.Number') }}</span
                >
                <span class="pro-content" style="line-height: 32px">:</span>
                <InputNum
                  ref="inputNum"
                  :v-model="productNum"
                  :min="minNo"
                  :max="maxNo"
                  style="margin: 0px 10px"
                  @inputNo="inputNo"
                />
                <span class="pro-content" style="line-height: 32px"
                  >( {{ $t('PointsMall.Inventory') }}：{{
                    currentSku >= 0
                      ? skuList[currentSku] &&
                        skuList[currentSku].DetailInventory
                      : 0
                  }}
                  )</span
                >
              </div>
              <div style="margin-top: 30px">
                <el-button
                  class="pro-button liji"
                  style="
                    margin-left: 20px;
                    border: 2px solid #fb4748;
                    color: #fb4748;
                    font-weight: 800;
                  "
                  @click="goButy"
                >
                  {{ $t('PointsMall.Exchange') }}
                </el-button>
              </div>
            </div>
          </div>
        </div>
        <div class="pro-about">
          <div class="store-commend"></div>
          <div class="after-sale">
            <a-tabs type="card">
              <a-tab-pane key="1" :tab="$t('PointsMall.ProductDetails')">
                <div v-html="data.CommodityDescribe"></div>
              </a-tab-pane>
              <a-tab-pane key="2" :tab="$t('PointsMall.Evaluation')">
                <Evaluate :evaluateList="evaluateList" />
              </a-tab-pane>
              <!-- <a-tab-pane key="3" tab="售后保障">
                <AfterSale />
              </a-tab-pane> -->
            </a-tabs>
          </div>
        </div>
        <ExchangeModal
          ref="exchangeModal"
          :goodsType="goodsType"
          :selectedItem="selectedItem"
          @submitSuccess="getDetailData(currentPId)"
        />
      </div>
    </div>
  </page-view>
</template>

<script>
import { PageView } from "@/components";
// import AfterSale from './components/afterSale.vue'
import Evaluate from "./components/evaluate.vue";
// import Introduction from './components/introduction.vue'

import InputNum from "./components/inputNumber";
import PicZoom from "./components/PicZoom";
import ExchangeModal from "./components/exchangeModal";
// import EntVerifyModal from '@/components/EntVerifyModal'
// import PromptModal from '@/components/EntVerifyModal/components/PromptModal'
// import ComplateInfomation from '@/components/complateInfomation'

// import { attentionProduct, } from '@/api/product'
import { getProductsById } from "@/api/pointsMall";

export default {
  name: "ProductDetail",
  components: {
    PageView,
    InputNum,
    PicZoom,
    ExchangeModal,
    // AfterSale,
    Evaluate,
    // Introduction,
    // EntVerifyModal,
    // PromptModal,
    // ComplateInfomation
  },
  key(route) {
    return route.fullPath;
  },
  data() {
    return {
      entVerifyVisible: false,
      promptModalVisible: false,
      productNum: 1, // 兑换数量
      // imgUrl: process.env.OELEM_URL + '/resource/img/',
      imgUrl: "/resource/img/",
      minNo: 1,
      maxNo: 100,
      sameProductList: [],
      data: {},
      skuList: [], // 规格选项
      currentSku: 0, // 当前选中的规格下标
      evaluateList: [], // 评价列表
      prodcutPics: [
        {
          url: require("@/assets/images/pointsMall/buildingBlocks.jpg"),
          id: 1,
        },
        {
          url: require("@/assets/images/pointsMall/mobilePower.jpg"),
          id: 2,
        },
        {
          url: require("@/assets/images/pointsMall/model.jpg"),
          id: 3,
        },
      ],
      currentPId: "", // 当前商品id
      goodsType: 0,
      selectedItem: {},
      specificationsRemark: '--'
    };
  },
  computed: {
    userInfo() {
      return this.$store.state.user.info;
    },
  },
  async created() {
    this.currentPId = this.$route.query.pid;
    await this.getDetailData(this.currentPId);
  },
  mounted() {
    // this.$refs.piczoom && this.$refs.piczoom.setPicList(this.prodcutPics)
    const user = this.$store.state.user.info;
    // if (user.userId && !user.addIndustry) {
    //   this.$refs.complateInfomation.open()
    // }
  },
  methods: {
    // ...mapActions(['getCartCount']),
    goToMall() {
      this.$router.push({
        name: "pointsMall",
      });
    },
    async getDetailData(pId) {
      console.log("当前商品id", pId);
      if (!pId) {
        return;
      }
      const res = await getProductsById({ id: pId, CommodityLanguageType: this.$ls.get('lang') == 'zh' ? 0 : 1, }).catch((err) => {
        console.log(err);
      });
      if (res.code == 200) {
        const info = res.data || {};
        const skuList = res.dataDetail || [];
        let currentSkuIndex = 0;
        // 多sku 默认选中
        if (skuList.length > 1) {
          currentSkuIndex = skuList.findIndex((item) => item.ProductID == pId);
        }
        this.data = info;
        this.seo = info;
        // this.isActive = info.attentionProduct ? 0 : 1
        this.skuList = skuList;
        console.log("商品规格", this.skuList);
        this.currentSku = currentSkuIndex > 0 ? currentSkuIndex : 0;
        this.onChange();
        if (info.CommodityPicDetail) {
          const arr = info.CommodityPicDetail.split(",");
          this.prodcutPics = arr.map((item, index) => {
            return {
              url: item,
              id: index,
            };
            // return { url: process.env.OELEM_URL + '/resource/img/' + item.picUrl, id: index }
          });
        } else {
          this.prodcutPics = [];
        }
        console.log("商品轮播图", this.prodcutPics);
        this.$refs.piczoom && this.$refs.piczoom.setPicList(this.prodcutPics);
        // sameProductList: same.data || [],
        this.productId = pId;
        this.evaluateList = res.dataEvaluation || [];
        console.log("评价列表", this.evaluateList);
      } else {
        return {};
      }
    },
    // 切换sku
    onChange() {
      // this.minNo = this.currentSku >= 0 ? Number(this.skuList[this.currentSku] && this.skuList[this.currentSku].pminQuantity) : 0
      this.maxNo =
        this.currentSku >= 0
          ? Number(
            this.skuList[this.currentSku] &&
            this.skuList[this.currentSku].DetailInventory
          )
          : 0;
      this.specificationsRemark = this.skuList[this.currentSku].Remark || '--'
      this.productNum = this.minNo;
      this.$refs.inputNum && this.$refs.inputNum.setValue(this.productNum);
    },
    inputNo(val) {
      this.productNum = Number(val);
      this.$refs.inputNum.setValue(this.productNum);
    },
    // 兑换
    goButy() {
      this.selectedItem = {
        CommodityName: this.data.CommodityName,
        Num: this.productNum,
        ...this.skuList[this.currentSku],
        // ID: this.skuList[this.currentSku] && this.skuList[this.currentSku].ProductID,
        // Integral: this.skuList[this.currentSku] && this.skuList[this.currentSku].DetailIntegral
      };
      this.goodsType = this.data.CommodityType;
      // this.handleClose()
      this.$refs.exchangeModal.handleClose();
    },
  },
};
</script>
<style lang="less">
.proDetail {
  background: #f0f6fb;
  // width: 1200px;
  // margin: 0 auto;
  // padding: 40px 0px;
  .product-detail {
    padding: 10px 20px 20px 20px;
    background: #f0f6fb;
    .back-wrap {
      width: 100%;
      margin-bottom: 10px;
      // font-size: 14px;
      .btn-nav-back {
        padding: 6px 8px;
        margin-right: 12px;
        &.el-button--default {
          color: #606266 !important;
          border-color: #dcdfe6 !important;
        }
      }
      .back-arrow {
        color: #51abc3;
        cursor: pointer;
        margin-left: 15px;
      }
    }
  }
  .proInfo {
    display: flex;
    justify-content: flex-start;
    background-color: white;
  }
  .imageBanner {
    width: 430px;
    margin-right: 24px;
  }
  .proParams {
    width: 100%;
    text-align: start;
  }
  .proName {
    font-weight: 600;
    color: #1f2937;
    line-height: 28px;
    font-size: 20px;
  }
  .pro-spec {
    font-size: 13px;
    font-weight: 400;
    color: #6b7280;
    line-height: 22px;
    margin-top: 5px;
  }
  .pro-price {
    width: 100%;
    height: 70px;
    background: #f3f4f7;
    border-radius: 4px;
    margin-top: 11px;
    padding: 20px;
    display: flex;
  }
  .pro-label {
    width: 80px;
    font-size: 13px;
    font-weight: 400;
    color: #6b7280;
    line-height: 18px;
  }
  .pro-content {
    font-size: 13px;
    font-weight: 400;
    color: #1f2937;
    line-height: 18px;
  }
  .pro-detail {
    display: flex;
    margin-top: 10px;
    line-height: 18px;
  }
  .pro-button {
    width: 156px;
    height: 46px;
    border-radius: 23px;
    &.add-cart,
    &.inquiry {
      @apply border-mwred-light;
    }
  }
  .ant-radio-wrapper:hover {
    color: #5abeda;
  }
  .ant-radio {
    display: none;
  }
  .select {
    color: #1f2937;
    border: 1px solid #d1d5db;
    border-radius: 4px;
    // width: 102px;
    height: 34px;
    text-align: center;
    margin: 10px 8px;
    font-weight: 500;
    font-size: 14px;
    padding: 0px;
    line-height: 34px;
  }
  .selected {
    color: #5abeda;
    border: 1px solid #5abfdc;
    border-radius: 4px;
    // width: 102px;
    height: 34px;
    text-align: center;
    margin: 10px 8px;
    font-weight: 500;
    font-size: 14px;
    padding: 0px;
    line-height: 34px;
  }
  .ant-popover-inner {
    width: 300px;
  }
  .anticon {
    vertical-align: initial;
  }
  .pro-about {
    display: flex;
    justify-content: flex-start;
    background-color: white;
    // padding-top:50px;
    padding-top: 25px;
  }
  // .store-commend{
  //   width: 202px;
  //   margin-right: 20px;
  //   background-color: white;
  // }
  .store-qualification {
    width: 100%;
    border-radius: 4px;
    border: 1px solid #e5e7eb;
    text-align: center;
    padding-bottom: 10px;
  }
  .after-sale {
    width: 100%;
  }
  .ant-tabs-nav-scroll {
    background: #f3f4f7;
    height: 46px;
  }
  .ant-tabs.ant-tabs-card .ant-tabs-card-bar .ant-tabs-tab {
    width: 124px;
    height: 40px;
    margin: 0;
    padding: 0 16px;
    line-height: 38px;
    background: #f3f4f7;
    border: none;
    transition: all 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);
    text-align: center;
    font-size: 14px;
    font-weight: 400;
    border-top: 3px solid #f3f4f7;
    border-radius: 0px;
  }
  .ant-tabs.ant-tabs-card .ant-tabs-card-bar .ant-tabs-tab-active.ant-tabs-tab {
    width: 124px;
    height: 40px;
    margin: 0;
    padding: 0 16px;
    line-height: 38px;
    background: #fff;
    border: none;
    transition: all 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);
    text-align: center;
    font-size: 14px;
    font-weight: 400;
    border-top: 3px solid #59c3e1;
    border-radius: 0px;
  }
  .ant-carousel .custom-slick-arrow {
    width: 25px;
    height: 25px;
    font-size: 25px;
    color: #fff;
    background-color: rgba(31, 45, 61, 0.11);
    opacity: 0.3;
  }
  .ant-carousel .custom-slick-arrow:before {
    display: none;
  }
  .ant-carousel .custom-slick-arrow:hover {
    opacity: 0.5;
  }
  .liji.ant-btn:hover,
  .liji.ant-btn:focus {
    color: white;
    background-color: white;
    border-color: white;
  }
}
.ant-popover-inner-content {
  padding: 12px 16px;
  color: #6b7280;
  border: 1px solid #d5eef4;
  background: #d5eef4;
  border-radius: 4px;
}
.ant-popover-arrow {
  display: none;
}
</style>
